import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ThisPlatform } from "../_services/platform.service";

@Component({
  selector: "app-page-not-found",
  templateUrl: "./page-not-found.page.html",
  styleUrls: ["./page-not-found.page.scss"],
})
export class PageNotFoundPage {
  constructor(
    public translateService: TranslateService,
    public p: ThisPlatform
  ) {}
}
